import { rootEventBus, EnumRootEventBus } from "../../../managers/RootEventBus";
import CustomSliderRenderer from "./CustomSliderRenderer";
import { BaseSliderProps } from "../../../types/Interface";
import addInteractivity from "../../../utils/addInteractivity";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class CustomSlider {
  private CustomSliderRenderer!: CustomSliderRenderer;
  private options!: BaseSliderProps;
  private handleOnUpdate: (value: number) => void;

  constructor(props: BaseSliderProps, handleOnUpdate: (value: number) => void) {
    this.options = { ...props };
    this.CustomSliderRenderer = new CustomSliderRenderer(this.options);
    this.handleOnUpdate = handleOnUpdate;
    this.addOnupdateSlider();
    this.addHandleEvent();
  }
  public setScale = (x: number, y: number) => this.CustomSliderRenderer.scale.set(x, y);
  public setSliderVisible = (v: boolean) => this.CustomSliderRenderer.visible = v;
  private onHandleEnd = () => {
    rootEventBus.emit(EnumRootEventBus.setRefRadians);
    if (!this.options.keepCurrSlider) { this.CustomSliderRenderer.Slider.value = 100 }
  };
  private addHandleEvent() {
    const handleUpFunc = () => this.onHandleEnd();
    addInteractivity(this.CustomSliderRenderer.Slider, { handleUpFunc }, CustomCursorType.pointer, undefined, true);
    this.CustomSliderRenderer.getBarGraphs().forEach(e => addInteractivity(e, {}, CustomCursorType.default));
  }
  private addOnupdateSlider() {
    this.CustomSliderRenderer.Slider.onUpdate.connect((value) => this.handleOnUpdate(value));
  }
}